import React from "react";
import styled from "styled-components";
import stairs1Img from "../../images/stairs_1.svg";
import stairs2Img from "../../images/stairs_2.svg";
import stairs3Img from "../../images/stairs_3.svg";
import stairs4Img from "../../images/stairs_4.svg";

const StyledWrapper = styled.section`
  background-color: #ffffff;
  color: #000000;
  font-family: Inter;
  font-size: 28px;
  font-weight: 400;
  line-height: 36px;
  letter-spacing: 0em;
  font-weight: 400;
  text-align: center;

  .heading {
    font-size: 45px;
    font-weight: 700;
    line-height: 52px;
    letter-spacing: -0.02em;
    margin-bottom: 8px;
  }

  .step-container {
    margin-top: 67px;
    padding: 0 23vw;
    @media (max-width: 768px) {
      margin-top: 60px;
      padding: 0 21px 0 18px;
    }
  }

  .step-header {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 17px;
  }

  .step-img {
    width: 20px;
    height: 21.36px;
    margin-right: 16px;
  }

  .step-title {
    font-size: 16px;
    font-weight: 700;
    line-height: 19px;
    letter-spacing: 0.03em;
    text-align: left;
  }

  .step-content {
    font-size: 28px;
    font-weight: 400;
    line-height: 36px;
    letter-spacing: 0em;
    text-align: center;
    @media (max-width: 768px) {
      font-size: 24px;
      line-height: 32px;
    }
  }
`;

const Promises = () => {
  return (
    <StyledWrapper>
      <div className="heading">
        How do we keep these
        <br /> promises?
      </div>

      <div className="step-container">
        <div className="step-header">
          <img src={stairs1Img} className="step-img" />
          <div className="step-title">STEP 1</div>
        </div>
        <div className="step-content">We partner with your favorite apps.</div>
      </div>

      <div className="step-container">
        <div className="step-header">
          <img src={stairs2Img} className="step-img" />
          <div className="step-title">STEP 2</div>
        </div>
        <div className="step-content">
          Our sophisticated algorithms identify the select few who receive the
          best offers in the industry.
        </div>
      </div>

      <div className="step-container">
        <div className="step-header">
          <img src={stairs3Img} className="step-img" />
          <div className="step-title">STEP 3</div>
        </div>
        <div className="step-content">
          Our team works hard to quickly verify your details, over a call and in
          person.
        </div>
      </div>

      <div className="step-container">
        <div className="step-header">
          <img src={stairs4Img} className="step-img" />
          <div className="step-title">STEP 4</div>
        </div>
        <div className="step-content">
          Our support team is always a call away, ensuring a smooth process
          throughout
        </div>
      </div>
    </StyledWrapper>
  );
};

export default Promises;
